/* =========================================================
   strive-dealeasy-fix.js (V4 - MARGIN FIX)
   Transforma dropdowns de Dealeasy en Chips Strive
   ========================================================= */

(function () {
  "use strict";

  // =========================================================
  // --- CHIP CONFIGURATION (Edita los valores aquí) ---
  // =========================================================
  const CONFIG = {
    // --- Typography ---
    font_size: "12px",
    font_weight: "400",

    // --- Colors: SELECTED ---
    selected_bg_color: "#000",
    selected_text_color: "#fff",
    selected_border_color: "#000",

    // --- Colors: UNSELECTED ---
    unselected_bg_color: "#fff",
    unselected_text_color: "#000",
    unselected_border_color: "#d1d1d1",

    // --- Layout & Spacing ---
    border_radius: "20px",
    padding: "8px 16px",
    chip_gap: "8px",             // Espacio horizontal *entre* chips
    row_margin_top: "4px",       // Espacio ARRIBA de cada fila de chips (Ej: 0px, 4px)
    row_margin_bottom: "4px",    // Espacio ABAJO de cada fila de chips (Ej: 0px, 4px)
  };
  // =========================================================

  function* deepRoots() {
    yield document;
    const stack = [document.documentElement];
    while (stack.length) {
      const node = stack.pop();
      if (!node) continue;
      if (node.shadowRoot) {
        yield node.shadowRoot;
        node.shadowRoot.querySelectorAll("*").forEach(el => stack.push(el));
      }
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) stack.push(node.children[i]);
      }
    }
  }

  function setNativeValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
    
    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
      prototypeValueSetter.call(element, value);
    } else if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      element.value = value;
    }
  }

  function transformToChips() {
    for (const root of deepRoots()) {
      const selects = root.querySelectorAll('select');

      selects.forEach((sel) => {
        if (sel.dataset.chipsProcessed === "true" || sel.options.length <= 1) return;

        const isDealeasy = sel.closest('[class*="dealeasy"]') || 
                           sel.closest('[class*="de-"]') || 
                           sel.closest('.shopify-app-block');
        
        if (!isDealeasy) return;

        sel.dataset.chipsProcessed = "true";
        sel.style.setProperty("display", "none", "important");

        // Hack extra: Quitarle el margen propio a Dealeasy si lo tiene
        if (sel.parentElement) {
          sel.parentElement.style.setProperty("margin-bottom", "0px", "important");
          sel.parentElement.style.setProperty("padding-bottom", "0px", "important");
        }

        const container = document.createElement("div");
        container.className = "strive-de-chips-wrapper";
        
        // Aquí aplicamos !important para que Dealeasy no nos sobreescriba el diseño
        container.style.setProperty("display", "flex", "important");
        container.style.setProperty("flex-wrap", "wrap", "important");
        container.style.setProperty("gap", CONFIG.chip_gap, "important");
        container.style.setProperty("margin-top", CONFIG.row_margin_top, "important");
        container.style.setProperty("margin-bottom", CONFIG.row_margin_bottom, "important");

        Array.from(sel.options).forEach((opt, idx) => {
          if (!opt.value || opt.disabled || opt.text.toLowerCase().includes("escoge")) return;

          const btn = document.createElement("button");
          btn.type = "button";
          btn.textContent = opt.text.replace(/^\d+\s/, ''); 
          
          const updateStyle = () => {
            const isSelected = sel.value === opt.value;
            btn.style.cssText = `
              padding: ${CONFIG.padding} !important;
              border-radius: ${CONFIG.border_radius} !important;
              font-size: ${CONFIG.font_size} !important;
              font-weight: ${CONFIG.font_weight} !important;
              cursor: pointer !important;
              transition: all 0.2s ease !important;
              outline: none !important;
              border: 1px solid ${isSelected ? CONFIG.selected_border_color : CONFIG.unselected_border_color} !important;
              background-color: ${isSelected ? CONFIG.selected_bg_color : CONFIG.unselected_bg_color} !important;
              color: ${isSelected ? CONFIG.selected_text_color : CONFIG.unselected_text_color} !important;
            `;
          };

          btn.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            setNativeValue(sel, opt.value);
            sel.selectedIndex = idx;
            
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            sel.dispatchEvent(new Event('input', { bubbles: true }));

            container.querySelectorAll('button').forEach(b => b.dispatchEvent(new Event('refresh')));
          };

          btn.addEventListener('refresh', updateStyle);
          updateStyle();
          container.appendChild(btn);
        });

        sel.parentNode.insertBefore(container, sel.nextSibling);
      });
    }
  }

  let isRunning = false;
  function run() {
    if (isRunning) return;
    isRunning = true;
    try { transformToChips(); } 
    finally { isRunning = false; }
  }

  let attempts = 0;
  const timer = setInterval(() => {
    run();
    attempts++;
    if (attempts > 40) clearInterval(timer);
  }, 250);

  const observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });

})();